<script type="text/babel">

function checkPermition (el, binding, vnode, show = true) {
    let visible = false;
    let { role = undefined, context = undefined } = vnode.context.$store.getters.getUser;

    if(role === 'key_account' && context.length > 0)
        role = "shop_owner"

    binding.value.forEach((r) => {
        if(role === r) visible = true;
    });
    if(!show) visible = !visible;
    if(!visible) el.style.display = 'none';
}
const guardShow =  {
        bind: function(el, binding, vnode) {
            checkPermition(el, binding, vnode)
        },
        update: function(newRoles, oldRoles) {
            checkPermition(el, binding, vnode)
        }
    }
const guardHide = {
        bind: function(el, binding, vnode) {
            checkPermition(el, binding, vnode, false)
        },
        update: function(newRoles, oldRoles) {
            checkPermition(el, binding, vnode, false)
        }
}
export default {
    guardShow,
    guardHide
}
export {
    guardShow,
    guardHide
}

</script>
